import React from "react";
import { Link } from "react-router-dom";
import HeaderQRCode from "../images/headerlogo.png";
import FooterQRCode from "../images/Footer_Qrcode.jpeg";
import LazyLoad from "react-lazyload";
import {
  FaFacebookF,
  FaInstagram,
  FaTiktok,
  // FaXTwitter,
} from "react-icons/fa6";

const Footer = () => {
  return (
    <footer
      className="text-white py-16 font-poppins"
      style={{ backgroundColor: "#064049" }} // Matches the exact teal color in your image
    >
      <div className="container mx-auto px-6 md:px-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 text-left items-start">
          {/* Main Title and QR Section */}
          <div className="md:col-span-4">
            <div className="text-4xl font-bold leading-tight mb-8">
              <LazyLoad>
                <img src={HeaderQRCode} alt="logo" />
              </LazyLoad>
            </div>
            <div className="bg-white p-1 inline-block rounded-sm">
              <a
                href="https://onelink.to/bmtr94"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LazyLoad height={120} offset={100}>
                  <img
                    src={FooterQRCode}
                    alt="QR Code"
                    style={{
                      width: "120px",
                      height: "120px",
                      cursor: "pointer",
                    }}
                  />
                </LazyLoad>
              </a>
            </div>
          </div>

          {/* Resources Column */}
          <div className="md:col-span-2">
            <h3 className="text-lg font-bold mb-6">Resources</h3>
            <ul className="space-y-4">
              <li>
                <Link
                  to="/deliverymantax"
                  className="text-white hover:opacity-80 transition-opacity text-sm"
                >
                  Courier
                </Link>
              </li>
              <li>
                <Link
                  to="/delivery"
                  className="text-white hover:opacity-80 transition-opacity text-sm"
                >
                  Driver
                </Link>
              </li>
              <li>
                <Link
                  to="/Resturants"
                  className="text-white hover:opacity-80 transition-opacity text-sm"
                >
                  Restaurant Owner
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div className="md:col-span-2">
            <h3 className="text-lg font-bold mb-6">Company</h3>
            <ul className="space-y-4">
              <li>
                <Link
                  to="/"
                  className="text-white hover:opacity-80 transition-opacity text-sm"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/service"
                  className="text-white hover:opacity-80 transition-opacity text-sm"
                >
                  Service
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-white hover:opacity-80 transition-opacity text-sm"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/support"
                  className="text-white hover:opacity-80 transition-opacity text-sm"
                >
                  Support
                </Link>
              </li>
              <li>
                <Link
                  to="/blogs"
                  className="text-white hover:opacity-80 transition-opacity text-sm"
                >
                  Blogs
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links Column */}
          <div className="md:col-span-2">
            <h3 className="text-lg font-bold mb-6">Quick Links</h3>
            <ul className="space-y-4">
              <li>
                <Link
                  to="#"
                  className="text-white hover:opacity-80 transition-opacity text-sm"
                >
                  Food
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="text-white hover:opacity-80 transition-opacity text-sm"
                >
                  Supermarket
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="text-white hover:opacity-80 transition-opacity text-sm"
                >
                  Suuq
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Icons Section */}
          <div className="md:col-span-2 flex space-x-6 justify-start md:justify-end">
            <a
              href="https://www.tiktok.com/@dhaweeye3000"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white text-xl hover:opacity-70"
            >
              {/* <FaXTwitter /> */}
              <FaTiktok />
            </a>
            <a
              href="https://www.facebook.com/Dhaweeye"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white text-xl hover:opacity-70"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.instagram.com/dhaweeye?igsh=MTYxMmtoMHk3ZGZqdQ%3D%3D&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white text-xl hover:opacity-70"
            >
              <FaInstagram />
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-20 pt-8 border-t border-white border-opacity-20 text-center">
          <p className="text-xs opacity-80">
            © {new Date().getFullYear()} Dhaweeye, All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
